// extracted by extract-css-chunks-webpack-plugin
module.exports = {"leftColumn":"_3yHLFy","dividerClass":"_3A2R-M","authorContent":"_3wrGCF","flexDirection":"_1tUDnH","renderToolTip":"_19VuHZ"};